import { render, staticRenderFns } from "./StatisticView.vue?vue&type=template&id=40e1c8d4&scoped=true&"
import script from "./StatisticView.vue?vue&type=script&lang=js&"
export * from "./StatisticView.vue?vue&type=script&lang=js&"
import style0 from "./StatisticView.vue?vue&type=style&index=0&id=40e1c8d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e1c8d4",
  null
  
)

export default component.exports